export default "__VITE_ASSET__ikaAu$VO__"